import { render, staticRenderFns } from "./EfsStdMarginForm.vue?vue&type=template&id=22f1121c&scoped=true&"
import script from "./EfsStdMarginForm.vue?vue&type=script&lang=js&"
export * from "./EfsStdMarginForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22f1121c",
  null
  
)

export default component.exports